import Cookies from 'js-cookie';

const ABTEST_COOKIE = 'abtest';

export function getUserId() {
    const userIdIndex = 2;
    return getDataFromPulseCookie(userIdIndex);
}

export function getAdId() {
    const adIdIndex = 9;
    return getDataFromPulseCookie(adIdIndex);
}

export function getDataFromPulseCookie(i: number) {
    const cookie =
        decodeURIComponent(
            document.cookie.replace(
                new RegExp(
                    `(?:(?:^|.*;)\\s*${encodeURIComponent(
                        '_pulse2data',
                    ).replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`,
                ),
                '$1',
            ),
        ) || false;
    if (cookie) {
        return cookie.split(',')[i];
    }
    return;
}

export function getAbTestCookie() {
    const abTestCookie = Cookies.get(ABTEST_COOKIE);
    let activeAbTests = '';

    if (abTestCookie) {
        try {
            activeAbTests = Object.keys(JSON.parse(abTestCookie)).join(',');
        } catch (e) {
            if (window.trackJs) {
                window.trackJs.track(`abtest cookie: ${abTestCookie}`);
            }
        }
    }
    return activeAbTests;
}

export function getSession() {
    return Cookies.get('SESSION');
}
